import { type Registry as Services, service } from '@ember/service';
import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';
import type { HoteldateTransformReturn } from 'lumen/transforms/hoteldate';

export default class RoomTypeRecommendation extends Model {
  [Type] = 'room-type-recommendation' as const;

  @attr('number') declare currentValue: number;
  @attr('hoteldate') declare fromDate: NonNullable<HoteldateTransformReturn>;
  @attr('number') declare recommendedValue: number;
  @attr('string') declare roomName: string;
  @attr('string') declare roomType: string;

  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithHotel;
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedCurrentValue() {
    if (this.currentValue) {
      return this.hotelAndMarketService.formatRate(this.currentValue, {
        longFormat: false,
      });
    }

    return this.intl.t('general.missing');
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedRecommendedValue() {
    if (this.recommendedValue) {
      return this.hotelAndMarketService.formatRate(this.recommendedValue, {
        longFormat: false,
      });
    }

    return this.intl.t('general.missing');
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isBaseRoom() {
    const pmsLeadingRoomId =
      this.hotelAndMarketService.hotel.caxxxPmsSettings['pms_leading_room_id'];

    // If room name is equals to the booking room name mapped to PMS leading room
    return (
      this.roomName ===
      this.hotelAndMarketService.hotel.caxxxPmsSettings[
        'pms_id_to_booking_room_name_mapping'
      ][pmsLeadingRoomId]
    );
  }
}
